import { Field, TextOutput } from 'Components/Core';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createSievingPortionLabelSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import React from 'react';
import { useSelector } from 'react-redux';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import PortionSievingDetailsSection from './PortionSievingDetailsSection';
import PortionSievingEquipmentSection from './PortionSievingEquipmentSection';
import PortionSievingRecordGridSection from './PortionSievingRecordGridSection';

let PortionSievingPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  let sievingPortionLabel = useSelector(createSievingPortionLabelSelector(createWorksheetSelector!, namePrefix!));

  const isCoarseSieving = namePrefix!.endsWith('.CoarsePortion');

  // Special case: use different label for Sieve Portion because we were asked to
  if (sievingPortionLabel === 'Sieve Portion') sievingPortionLabel = 'Portion';

  return (
    <PageSection heading={`${sievingPortionLabel} Sieving`}>
      <PortionSievingDetailsSection />
      <NamePrefixModifier appendNamePrefix="Sieving">
        <PortionSievingEquipmentSection />
        <PortionSievingRecordGridSection />
        <ListFieldSection visible={isCoarseSieving}>
          <Field input={<TextOutput />} label={`${sievingPortionLabel} Loss (%)`} name="PortionLoss" />
        </ListFieldSection>
      </NamePrefixModifier>
    </PageSection>
  );
};

PortionSievingPageSection = withInjectedProps(PortionSievingPageSection);

export { PortionSievingPageSection };
export default PortionSievingPageSection;
